<template>
  <div class="app-inner">
    <div class="searchTitleDiv">
      <div class="stateDiv">
        <p class="searchText">园区名称</p>
        <el-input v-model="searchFrom.parkName" placeholder="请输入" clearable class="inputDiv"></el-input>
      </div>
      <div class="stateDiv">
        <p class="searchText">园区属性</p>
        <el-select v-model="searchFrom.parkBelong" placeholder="请选择"  class="inputDiv" clearable>
          <el-option v-for="item in parkBelongOptions" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div>
      <!-- <div class="stateDiv">
        <p class="searchText">园区等级</p>
        <el-select v-model="searchFrom.parkLevel" placeholder="请选择" class="inputDiv" clearable>
          <el-option v-for="item in parkLevelOptions" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div> -->
      <div class="stateDiv">
        <p class="searchText">园区地址</p>
        <el-input v-model="searchFrom.parkAddress" placeholder="请输入" clearable class="inputDiv"></el-input>
      </div>
      <el-button class="searchBtn" type="primary" @click="getData">查 询</el-button>
      <el-button class="searchBtn" type="warning" @click="addFormData">新增园区</el-button>
    </div>
    <!--      列表-->
    <div class="table">
      <div class="searchList">
        <el-table v-loading="loading" :data="tableData" :default-sort="{ prop: 'id', order: 'descending' }"
          style="width: 100%" :highlight-current-row="false"
          :header-cell-style="{ background: '#F4F7FA', color: '#606266' }">
          <el-table-column label="园区名称" width="160" prop="parkName">
              <template slot-scope="scope">
                <el-link type="primary" :href="`${parkUrl}#/bigScreen?parkCode=${scope.row.parkCode}`" target="_blank">{{scope.row.parkName}}</el-link>
                <!-- <el-link type="primary" :href="`http://localhost:8080/#/bigScreen?parkCode=${scope.row.parkCode}`" target="_blank">{{scope.row.parkName}}</el-link> -->
              </template>
          </el-table-column>
          <template v-for="(item, index) in tableColumns">
            <el-table-column :key="index" :prop="item.prop" :label="item.label" :formatter="item.formatter"
              :width="item.width">
            </el-table-column>
          </template>
          <el-table-column label="操作" width="160">
            <template slot-scope="scope" class="tableButton">
              <el-button class="tableBtn" @click="viewOrHandle(scope.row, 'edit')" type="text" size="small">编辑</el-button>
              <!-- <el-button class="tableBtn" @click="viewOrHandle(scope.row, 'view')" type="text" size="small">查看详情</el-button> -->
              <el-button class="tableBtn" @click="deleteFun(scope.row)" type="text" size="small">删除</el-button>
              <el-button size="small" type="text" @click="openModal(scope.row)">留言查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total, prev, pager, next, jumper" :total="totalCount" class="paginationBody">
      </el-pagination>
    </div>
    <!--    新增/编辑弹框-->
    <div class="dialogDiv">
      <el-dialog :title="eventControl" class="editDialog" :visible.sync="dialogFormVisible" :before-close="closeData" center>
        <el-form ref="addForm" :model="addForm" :rules="rules" label-width="140px" :disabled="eventControl === '查看详情'">
          <el-row>
            <el-col :span="12">
              <el-form-item label="园区名称" prop="parkName" class="formItem">
                <el-input v-model="addForm.parkName" clearable placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="园区属性" prop="parkBelong" class="formItem">
                <el-select v-model="addForm.parkBelong" placeholder="请选择" style="width:100%">
                  <el-option v-for="item in parkBelongOptions" :key="item.value" :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="停车位数量" prop="parkingAmount" class="formItem">
                <el-input-number v-model="addForm.parkingAmount" clearable placeholder="请输入" :min="0" :precision="0">
                </el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="停车价格" prop="parkingPrice" class="formItem">
                <el-input-number v-model="addForm.parkingPrice" clearable placeholder="请输入" :min="0" :precision="2">
                </el-input-number> 元/小时
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="房租均价" prop="rentPrice" class="formItem">
                <el-input-number v-model="addForm.rentPrice" clearable placeholder="请输入" :min="0" :precision="2">
                </el-input-number>元/平米/日
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="物业均价" prop="managementFee" class="formItem">
                <el-input-number v-model="addForm.managementFee" clearable placeholder="请输入" :min="0" :precision="2">
                </el-input-number>元/平米/月
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="办公面积" prop="officeArea" class="formItem">
                <el-input-number v-model="addForm.officeArea" clearable placeholder="请输入" :min="0" :precision="2">
                </el-input-number>平方米
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="装修免租期" prop="rentFreeMonth" class="formItem">
                <el-input-number v-model="addForm.rentFreeMonth" clearable placeholder="请输入" :min="0" :precision="0">
                </el-input-number>月
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="已出租面积" prop="officeAreaRented" class="formItem">
                <el-input-number v-model="addForm.officeAreaRented" clearable placeholder="请输入" :min="0" :precision="0">
                </el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="未出租面积" prop="officeAreaNoRented" class="formItem">
                <el-input-number v-model="addForm.officeAreaNoRented" clearable placeholder="请输入" :min="0"
                  :precision="0"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="招商人员" prop="salesMan" class="formItem">
                <el-input v-model="addForm.salesMan" clearable placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="电话" prop="telephone" class="formItem">
                <el-input v-model="addForm.telephone" clearable placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="园区地址" prop="parkAddress" class="formItem">
                <el-input v-model="addForm.parkAddress" clearable placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="物业公司" prop="managementCompany" class="formItem">
                <el-input v-model="addForm.managementCompany" clearable placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="物业办公室电话" prop="managementOfficePhone" class="formItem">
                <el-input v-model="addForm.managementOfficePhone" clearable placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="物业经理电话" prop="managementManagerPhone" class="formItem">
                <el-input v-model="addForm.managementManagerPhone" clearable placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="H5园区宣传页展示" prop="managementOfficePhone" class="formItem">
                  <el-radio v-model="addForm.showOnH5Flag" :label="1">是</el-radio>
                  <el-radio v-model="addForm.showOnH5Flag" :label="0">否</el-radio>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="园区介绍" prop="parkDiscription" class="formItem">
            <el-input type="textarea" v-model="addForm.parkDiscription" clearable placeholder="请输入" maxlength="500" show-word-limit></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeData">取 消</el-button>
          <el-button type="primary" @click="addEventForm()" v-if="eventControl !== '查看详情'">保 存</el-button>
        </div>
      </el-dialog>
    </div>
    <el-dialog title="留言查看" :visible.sync="remarkDialogShow" width="59%">
      <el-table 
        :data="remarkTableData"
        :stripe="true"
        size="small"
      >
        <el-table-column 
          v-for="(item, index) in remarkTableColumns"
          :key="index"
          :property="item.prop" 
          :label="item.label" 
          :min-width="item.width"
          :show-overflow-tooltip="true"
        ></el-table-column>
      </el-table>
      <el-pagination @current-change="remarkHandleCurrentChange" :current-page.sync="remarkPagination.currentPage" :page-size="remarkPagination.pageSize"
        layout="total, prev, pager, next, jumper" :total="remarkPagination.totalCount" class="paginationBody" />
    </el-dialog>
  </div>
</template>

<script>
import { baseParkInfo, remarkList } from '@/api/basicInfo'
// import { validPassword } from '@/assets/scripts/validate'
import { Message } from 'element-ui'
export default {
  name: 'accountPage',
  data() {
    return {
      loading: false,
      searchFrom: {
        parkName: '', // 园区名称
        parkLevel: '', // 园区等级
        parkBelong: '', // 园区属性
        parkAddress: '', // 园区地址
      },
      currentPage: 1,
      totalCount: 0,
      pageSize: 10,
      dialogFormVisible: false,
      eventControl: '',
      parkUrl: '',
      edit: false,
      passwordForm: {},
      addForm: {
        parkName: '', // 园区名称
        parkLevel: '', // 园区等级
        parkBelong: '', // 园区属性
        parkingAmount: 0, // 停车位数量
        parkingPrice: 0, // 停车价格
        rentPrice: 0, // 房租均价
        managementFee: 0, // 物业均价
        officeArea: 0, // 办公面积
        rentFreeMonth: 0, // 装修免租期
        officeAreaRented: 0, // 已出租面积
        officeAreaNoRented: 0, // 未出租面积
        salesMan: '', // 招商人员
        telephone: '', // 电话
        parkAddress: '', // 园区地址
        managementCompany: '', // 园区地址
        managementOfficePhone: '', // 园区地址
        managementManagerPhone: '', // 园区地址
        parkDiscription: '', // 园区介绍
        showOnH5Flag: '' // 园区介绍
      },
      rules: {
        parkName: [{ required: true, message: '请填写', trigger: 'blur' }],
        parkLevel: [{ required: true, message: '请选择', trigger: 'blur' }],
        parkBelong: [{ required: true, message: '请选择', trigger: 'blur' }],
        rentPrice: [{ required: true, message: '请填写', trigger: 'blur' }],
        managementFee: [{ required: true, message: '请填写', trigger: 'blur' }],
        officeArea: [{ required: true, message: '请填写', trigger: 'blur' }],
        parkAddress: [{ required: true, message: '请填写', trigger: 'blur' }],
        parkDiscription: [{ required: true, message: '请填写', trigger: 'blur' }]
      },
      tableData: [],
      parkLevelOptions: [
        {
          label: '甲',
          value: '甲'
        },
        {
          label: '乙',
          value: '乙'
        },
        {
          label: '丙',
          value: '丙'
        },
        {
          label: '丁',
          value: '丁'
        }
      ],
      parkBelongOptions: [
        {
          label: '公有',
          value: '公有'
        },
        {
          label: '私有',
          value: '私有'
        },
        {
          label: '混合',
          value: '混合'
        },
        {
          label: '集体',
          value: '集体'
        }
      ],
      tableColumns: [
        // {
        //   prop: 'parkName',
        //   label: '园区名称'
        // },
        // {
        //   prop: 'parkLevel',
        //   label: '园区等级'
        // },
        {
          prop: 'parkBelong',
          label: '园区属性'
        },
        {
          prop: 'officeArea',
          label: '办公面积(m²)'
        },
        {
          prop: 'parkAddress',
          label: '园区地址'
        },
        {
          prop: 'officeAreaRented',
          label: '已出租面积'
        },
        {
          prop: 'officeAreaNoRented',
          label: '未出租面积'
        }
      ],
      remarkTableColumns: [
        { prop: 'name', label: '姓名', width: '120' },
        { prop: 'mobile', label: '联系电话', width: '150' },
        { prop: 'parkName', label: '意向园区', width: '150' },
        { prop: 'remark', label: '备注', width: '180' },
      ],
      remarkTableData: [],
      remarkDialogShow: false,
      remarkPagination: {
        currentPage: 1,
        totalCount: 0,
        pageSize: 10,
      },
      parkCode: ''
    }
  },
  mounted() {
    this.getData()
  },
  watch: {
    'addForm.officeAreaRented': function (oldVal, newVal) {
      if (this.addForm.officeArea <= 0) {
        return
      }
      if (newVal < this.addForm.officeArea) {
        this.addForm.officeAreaNoRented = this.addForm.officeArea - this.addForm.officeAreaRented
      }
    },
    'addForm.officeAreaNoRented': function (oldVal, newVal) {
      if (this.addForm.officeArea <= 0) {
        return
      }
      if (newVal < this.addForm.officeArea) {
        this.addForm.officeAreaRented = this.addForm.officeArea - this.addForm.officeAreaNoRented
      }
    }
  },
  methods: {
    getData() {
      console.log(process.env);
      this.parkUrl = process.env.VUE_APP_BASE_URL
      this.currentPage = 1
      this.queryList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.queryList()
    },
    async queryList() {
      let res = await baseParkInfo('query', {
        // parkName: this.searchFrom.parkName,
        // parkLevel: this.searchFrom.parkLevel,
        // parkBelong: this.searchFrom.parkBelong,
        // parkAddress: this.searchFrom.parkAddress,
        ...this.searchFrom,
        pageNum: this.currentPage,
        pageSize: this.pageSize
      })
      if (res.code === 0) {
        this.tableData = res.result.records
        this.totalCount = res.result.total
      }
    },
    addFormData() {
      this.edit = false
      this.dialogFormVisible = true
      this.eventControl = '新增园区'
    },
    async viewOrHandle(row, type) {
      this.edit = true
      this.eventControl = type === 'edit' ? '编辑园区' : '查看详情'
      this.newOldFormContrast(row)
      this.dialogFormVisible = true
    },
    newOldFormContrast(newForm) {
      Object.keys(this.addForm).forEach(key => {
        this.addForm[key] = newForm[key]
      })
      this.addForm.id = newForm.id
    },
    closeData() {
      this.dialogFormVisible = false
      this.$refs['addForm'].resetFields()
      this.addForm = this.$options.data.call(this).addForm
    },
    addEventForm() {
      this.$refs['addForm'].validate(async (valid) => {
        if (valid) {
          if (this.edit) {
            let res = await baseParkInfo('update', this.addForm)
            if (res.code === 0) {
              Message.success('编辑成功！')
              this.closeData()
              await this.getData()
            } else {
              Message.warning({ message: res.message })
            }
          } else {
            let res = await baseParkInfo('add', this.addForm)
            if (res.code === 0) {
              Message.success('新增成功！')
              this.closeData()
              await this.getData()
            } else {
              Message.error(res.message)
            }
          }
        }
      })
    },
    // 删除用户
    deleteFun (row) {
      this.$confirm('此操作将删除当前数据以及对应楼宇关联信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let params = {
          'id': row.id
        }
        let res = await baseParkInfo('deleteById', params)
        if (res.code === 0) {
          Message.success('删除成功！')
        }
        await this.getData()
      })
    },
    openModal(row) {
      this.parkCode = row.parkCode
      this.queryRemarkList()
      this.remarkDialogShow = true
    },
    remarkHandleCurrentChange(val) {
      this.remarkPagination.currentPage = val
      this.queryRemarkList()
    },
    async queryRemarkList() {
      const { pageSize, currentPage } = this.remarkPagination
      const params = {
        name: '',
        pageSize,
        pageNum: currentPage,
        intentionParkCode: this.parkCode
      }
      const data = await remarkList(params)
      if (data.code === 0) {
        const { records, total } = data.result
        this.remarkPagination.totalCount = total
        this.remarkTableData = records
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.app-inner {
  width: 98%;
  height: 70vh;
  padding: 0.2rem;
  box-sizing: border-box;
}

.searchTitleDiv {
  width: 15rem;
  min-height: 0.66rem;
  margin-left: 0.2rem;
  margin-top: 0.05rem;
  /*display: flex;*/
  /*justify-content: space-around;*/

  .stateDiv {
    margin-top: 0.14rem;
    margin-left: .3rem;
    float: left;
  }

  .searchText {
    margin-top: 0.05rem;
    margin-right: 0.13rem;
    font-size: 0.2rem;
    color: #111111;
    float: left;
  }

  .inputDiv {
    width: 2.2rem;
    float: left;
  }

  .searchBtn {
    /*width: 1.20rem;*/
    /*height: 0.36rem;*/
    /*border-radius: 0.06rem;*/
    /*font-size: 0.18rem;*/
    margin-top: 0.14rem;
    margin-left: .3rem;
    /*padding-top: 0.1rem;*/
  }
}

.table {
  margin-top: .3rem;
  margin-left: .5rem;
  text-align: center;
  width: 14.8rem;

  .searchList {}

  .paginationBody {
    margin-top: .1rem;
  }
}

.formItem {
  // width: 3.2rem;
}

/deep/ .el-dialog.editDialog {
  width: 50% !important;
}
/deep/ .el-table {
  th.gutter {
    display: initial;
    width: 0!important;
  }
}
.el-pagination {
  margin-top: 15px;
  text-align: right;
}
</style>
